export function isError(x: unknown): x is Error {
  return !!x && x instanceof Error;
}
